import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useParams } from "react-router-dom";

function Models({ data }) {
  const { name } = useParams();
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
  var bgColor=getParameterByName('bgcolor')
  return (
    <div style={{ height: "100vh" }}>
      {data
        .filter((item) => item.name === name)
        .map((item) => {
          return (
            <Carousel swipeable={false} showArrows={true} showThumbs={false}>
              {item.models.map((t) => {
                return (
                  <div className="full-card" key={item.id} style={{color:"#293292",backgroundColor:`#${bgColor}`}}>
                 

                    <model-viewer
                      zoom="0.2"
                      id="modelView"
                      bounds="tight"
                      src={t}
                      ar
                      ar-modes="webxr scene-viewer quick-look"
                      camera-controls
                      touch-action="pan-y"
                      poster={item.poster}
                      auto-rotate
                      shadow-intensity="1.43"
                      exposure="1.03"
                      shadow-softness="0.96"
                      style={{backgroundColor:`#${bgColor}`}}
                    >
                      <div className="progress-bar hide" slot="progress-bar">
                        <div className="update-bar"></div>
                      </div>
                     {/*  <button slot="ar-button" id="ar-button">
                        AR VIEW
                      </button> */}
                      <div id="ar-prompt">
                        <img src="ar_hand_prompt.png" />
                      </div>
                    </model-viewer>
                  </div>
                );
              })}
            </Carousel>
          );
        })}
        {/* <footer className="brand-footer">
         <a href="https://alphech.com"> <img src="/Assets/logo512.png"></img></a>
        </footer> */}
    </div>
  );
}

export default Models;
